import React from 'react';
import classNames from 'classnames';
import { Button } from '../Button';
import { Icon } from '../Icon';
import styles from './SearchBar.module.scss';

interface SearchBarProps extends React.InputHTMLAttributes<HTMLInputElement> {
	className?: string;
	variant?: 'default' | 'inverse';
	inputId: string;
}

const SearchBarComponent: React.ForwardRefRenderFunction<HTMLInputElement, SearchBarProps> = (
	{ className, variant = 'default', placeholder, inputId, ...rest },
	ref,
) => {
	return (
		<div className={classNames(styles.wrapper, { [styles.isInverse]: variant === 'inverse' }, className)}>
			<label className={'u-hide-visually'} htmlFor={inputId}>
				{inputId || ''}
			</label>
			<input
				className={styles.input}
				id={inputId}
				type={'search'}
				aria-label={inputId}
				placeholder={placeholder}
				ref={ref}
				{...rest}
			/>

			<Button
				className={styles.submitButton}
				type={'submit'}
				variant={'ghost'}
				hasOnlyIcon
				title={placeholder}
				aria-label={`submit ${inputId}`}
			>
				<Icon name={'search'} size={'md'} />
			</Button>
		</div>
	);
};

/**
 * SearchBar component, includes search input. Value can be uncontrolled or controlled.
 * Submit should be handled in parent component.
 */
export const SearchBar = React.forwardRef<HTMLInputElement, SearchBarProps>(SearchBarComponent);
